import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { primary, neutral } from 'lib/mui/colors';

export const ButtonPrimary = styled(Button)`
    color: ${neutral[0]};
    background: ${primary[700]};
    width: auto;
    padding: 8px 16px;
    border: 1px solid ${primary[700]};
    borderradius: 8px;
    :hover {
        color: ${neutral[0]};
        background: ${primary[500]};
    }
`;

export const ButtonSecondary = styled(Button)`
    color: ${primary[700]};
    width: auto;
    border: 1px solid ${primary[700]};
    borderradius: 8px;
    padding: 8px 16px;
    marginright: 16px;
    fontsize: bold;
    :hover {
        color: ${primary[700]};
    }
`;
